import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="py-8 md:py-16 px-4 bg-[#EDE6D8]" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-lg p-6 md:p-12 border-2 border-[#C2613A] text-center" data-id="element-131">
          <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          duration: 0.6
        }} className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-[#C2613A] rounded-full mb-4 md:mb-6" data-id="element-132">
            <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-white" data-id="element-133" />
          </motion.div>

          <h2 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4" data-id="element-134">
            7 DÍAS GARANTÍA TOTAL
          </h2>

          <div className="max-w-2xl mx-auto" data-id="element-135">
            <p className="text-base md:text-lg mb-4 md:mb-6 leading-relaxed font-medium" data-id="element-136">
              7 días para probarlo o te devolvemos el 100%
            </p>

            <p className="text-xs md:text-base text-[#2B2724]/80 leading-relaxed mb-4 md:mb-6" data-id="element-137">
              Abrís los tomos, probás los planos en tu taller, seguís el paso a
              paso. Si no es lo que esperabas: sin preguntas, sin formularios,
              sin drama. Tu inversión está protegida desde el primer minuto.
            </p>

            <p className="text-[10px] md:text-sm text-[#2B2724]/60" data-id="element-138">
              (Tasa de devoluciones menos del 1%)
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}